import { SchoolService, BaseService } from "@/services/school.service";

const ChallengeService = {
    getAll () {
        return SchoolService.getAll("challenges")
    },

    getByVisibility(visibility, state) {
    	let endpoint = 'challenges?visibility=' + visibility + '&state=' + state
        return SchoolService.getAll(endpoint)
    },

    add(payload) {
    	return SchoolService.create("challenges", payload)
    },

    update(object) {
    	return SchoolService.update("challenges", object.identifier, object)
    },


    delete(object) {
    	return SchoolService.delete("challenges", object.identifier, null)
    },

    purchase(object) {
        return SchoolService.create("challenges/" + object.identifier + "/purchase", null)
    },

    recind(object) {
        return SchoolService.delete("challenges/" + object.identifier + "/purchase", null)
    },

    getResultsByChallenge(object) {
        return SchoolService.getAll("challenges/" + object.identifier + "/results")
    },

    addResult(payload) {
        return SchoolService.create("challenges/results", payload)
    },

    updateResult(object) {
        return SchoolService.update("challenges/results", object.identifier, object)
    },

    deleteResult(object) {
       return SchoolService.delete("challenges/results", object.identifier, null) 
    }
     
}

export { ChallengeService };
